export const langText: any = {
    us: {
        also_like: 'You may also like:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Learn More',
        link_buy: 'Add to Cart',
        sold_out: 'Sold Out',
        total: 'Total',
        BuyNow: 'Buy Now',
    },
    de: {
        also_like: 'Sie benötigen außerdem:',
        affirm_text: 'Zinsfreie Zahlung in 6 Raten',
        link_more: 'Mehr erfahren',
        link_buy: 'Jetzt kaufen',
        sold_out: 'Ausverkauft',
        total: 'Gesamt',
        BuyNow: 'Jetzt kaufen',
    },
    fr: {
        also_like: 'Les clients ayant acheté cet article ont également acheté :',
        affirm_text: '*Six interest-free installments',
        link_more: 'En savoir plus',
        link_buy: 'Acheter maintenant',
        sold_out: 'Épuisé',
        total: 'Total',
        BuyNow: 'Acheter',
    },
    it: {
        also_like: 'Altri prodotti di cui potresti avere bisogno:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Saperne di più',
        link_buy: 'Acquista ora',
        sold_out: 'Esaurito',
        total: 'Totale',
        BuyNow: 'Acquista ora',
    },
    es: {
        also_like: 'Puede que también necesites:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Más información',
        link_buy: 'Comprar ahora',
        sold_out: 'Agotado',
        total: 'Total',
        BuyNow: 'Comprar ahora',
    },
    jp: {
        also_like: 'あなたへのおすすめ',
        affirm_text: '*6回無利息分割払い',
        link_more: '詳細はこちら',
        link_buy: '今すぐ購入',
        sold_out: '売り切れ',
        total: '合計',
        BuyNow: '今すぐ購入',
    },
    kr: {
        also_like: '당신을 위한 추천',
        affirm_text: '*6개월 무이자 할부',
        link_more: '더 알아보기',
        link_buy: '지금 구매',
        sold_out: '품절',
        total: '총액',
        BuyNow: '바로 구매하기',
    },
    sa: {
        also_like: 'موصى به لك',
        affirm_text: '*6 شهور بدون فوائد',
        link_more: 'تعرف على المزيد',
        link_buy: 'اشتري الآن',
        sold_out: 'غير متوفر',
        total: 'المجموع',
        BuyNow: 'اشتري الآن',
    },
    br: {
        also_like: 'You may also like:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Learn More',
        link_buy: 'Add to Cart',
        sold_out: 'Sold Out',
        total: 'Total',
        BuyNow: 'Comprar agora',
    },
    mx: {
        also_like: 'You may also like:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Learn More',
        link_buy: 'Add to Cart',
        sold_out: 'Sold Out',
        total: 'Total',
        BuyNow: 'Comprar ahora',
    },
};
